import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";
import useStore from "stores";
import { loginUrl } from "utils/api/ajax";
import "./style.scss";

const HomeHeader = observer((props) => {
  const { loginStore } = useStore();
  const history = useHistory();
  const [focused, setFocused] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const goto = (path) => {
    window.scrollTo(0, 0);
    history.push(path);
  }

  const handleFocus = () => {
    setFocused(true);
  }

  const handleBlur = () => {
    setFocused(false);
  }

  const handleInputValue = (e) => {
    setInputValue(e.target.value)
  }

  const handleSearch = () => {
    setInputValue("");
    window.open(`/search?k=${inputValue}`);
  }

  const handleSubmit = (e) => {
    if(e.keyCode == 13) {
      handleSearch();
    }
  }

  const handleClear = () => {
    setInputValue("");
  }

  
  return (
    <div className="home-header">
      <div className="nav">
        <div className="navItem">
          <Link
            to="/"
            className="navA"
            style={props.textStyle}
            clstag="pageclick|keycount|VopOpenIndex_1602911919488|1"
          >
            首页
          </Link>
        </div>
        <div className="navItem docList">
          <a
            href=""
            className="navA"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            行业解决方案<i></i>
          </a>
          <div className="list">
            <div className="listItema" onClick={() => goto('/solve/finance')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|11">
              金融保险
            </div>
            <div className="listItema" onClick={() => goto('/solve/manufacture')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|12">
              制造
            </div>
            <div className="listItema" onClick={() => goto('/solve/traffic')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|13">
              大交通
            </div>
            <div className="listItema" onClick={() => goto('/solve/operators')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|14">
              运营商
            </div>
            <div className="listItema" onClick={() => goto('/solve/energy')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|15">
              能源
            </div>
            <div className="listItema" onClick={() => goto('/solve/internet')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|16">
              互联网
            </div>
          </div>
        </div>
        <div className="navItem docList">
          <a
            href=""
            className="navA"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            组件中心<i></i>
          </a>
          <div className="list">
            <div className="listItema" onClick={() => goto('/component/index')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|41">
              组件服务简介
            </div>
            <div className="listItema" onClick={() => goto('/component/list')} clstag="pageclick|keycount|VopOpenIndex_1602911919488|33">
              组件能力地图
            </div>
          </div>
        </div>
        <div className="navItem docList">
          <a
            href=""
            className="navA"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            文档中心<i></i>
          </a>
          <div className="list">
            <Link
              className="listItema"
              to="/doc/api"
              clstag="pageclick|keycount|VopOpenIndex_1602911919488|2"
            >
              API文档
            </Link>
            <Link
              className="listItema"
              to="/doc/guide"
              clstag="pageclick|keycount|VopOpenIndex_1602911919488|3"
            >
              常用文档
            </Link>
            <Link
              className="listItema"
              to="/doc/faq"
              clstag="pageclick|keycount|VopOpenIndex_1602911919488|4"
            >
              常见问题
            </Link>
          </div>
        </div>
      </div>
      <div className="contr">
        {
          history.location.pathname !== '/search'
          ?
          <div className={ focused ? 'search-input focused' : 'search-input' }>
            <form>
              <input type="text" placeholder="搜索" value={ inputValue } onFocus={() => { handleFocus() }} onBlur={ () => { handleBlur() } } onChange={ (e) => { handleInputValue(e) } } onKeyDown={ (e) => { handleSubmit(e) } }  clstag="pageclick|keycount|VopOpenIndex_1602911919488|32"/>
            </form>
            <div className="search-oper">
              <span role="img" aria-label="magnifier" className="icon icon-magnifier" onClick={ (e) => { handleSearch(e) } }>
                <svg viewBox="0 0 1024 1024" focusable="false" data-icon="magnifier" width="12px" height="12px" fill="currentColor" aria-hidden="true">
                  <path d="M438.86 0c242.1 0 438.86 196.75 438.85 438.86 0 108.25-38.77 206.99-103.86 283.06l235.52 235.52c14.63 14.63 14.63 37.3 0 51.93-14.63 14.63-37.3 14.63-51.93 0L721.92 773.85c-76.8 65.1-175.54 103.86-283.06 103.86C196.76 877.71 0 680.96 0 438.86S196.75 0 438.86 0zm0 73.14c-201.87 0-365.71 163.84-365.72 365.72s163.84 365.71 365.72 365.71 365.71-163.84 365.71-365.71S640.73 73.15 438.86 73.14z"></path>
                </svg>
              </span>
              <span className="line" style={ inputValue.trim() ? {display: 'inline-block'} : {display: 'none'} }></span>
              <span role="img" aria-label="close" className="icon icon-close" onClick={ (e) => { handleClear(e) } } style={ inputValue.trim() ? {display: 'inline-block'} : {display: 'none'} }>
                <svg viewBox="0 0 1024 1024" focusable="false" data-icon="close" width="12px" height="12px" fill="currentColor" aria-hidden="true">
                  <path d="M58.03 10.24L480.6 432.13 903.17 10.24c11.61-11.61 30.04-12.97 43.69-4.1l4.78 4.1c13.65 13.65 13.65 34.82 0 47.79L529.07 480.6l422.57 422.57c13.65 13.65 13.65 34.82 0 48.47-13.65 13.65-34.82 13.65-48.47 0L480.6 529.07 58.03 951.64c-11.61 11.61-30.04 12.97-43.01 3.41l-4.78-3.41c-13.65-13.65-13.65-34.82 0-48.47L432.13 480.6 10.24 58.03c-13.65-13.65-13.65-34.82 0-47.79 13.65-13.65 34.82-13.65 47.79 0z"></path>
                </svg>
              </span>
            </div>
          </div>
          :
          ""
        }
        
        <Link to={loginStore.isLogin ? "/app/frame" : loginUrl} clstag="pageclick|keycount|VopOpenIndex_1602911919488|17">
          管理控制台
        </Link>
      </div>
    </div>
  );
});
export default HomeHeader;
